<template>
  <div class="locale-changer">
    <v-select
      v-model="lang"
      :items="langs"
      solo
      class="no-margins"
      flat
      dense
      hide-details
      single-line
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Languages } from '@/locale'

// @group Common
// Styled LocaleChanger component
export default {
  name: 'LocaleChanger',

  data: function () {
    return {
      lang: '',
      langs: []
    }
  },

computed: {
    ...mapGetters('app', ['locale','isInitialized']),
  },

  watch: {
    lang (val) {
      if (this.isInitialized) {
        this.$i18n.locale = val
        this.setLocale(val)
      }
    },
    isInitialized () {
      this.lang = this.locale
    }
  },

  created () {
    this.langs = Languages
    this.lang = this.locale
  },

  methods: {
    ...mapActions('app', ['setLocale']),
  }
}
</script>

<style scoped>
</style>